function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.503 0c.839 0 1.587.437 2.001 1.174l4.185 7.318c.417.729.414 1.6-.005 2.331A2.3 2.3 0 0110.674 12h-8.36a2.28 2.28 0 01-1.995-1.158 2.34 2.34 0 01-.008-2.345L4.5 1.171A2.28 2.28 0 016.503 0zm0 1.058c-.46 0-.866.237-1.093.64L1.22 9.02c-.23.405-.228.885.002 1.287.227.397.636.632 1.09.632h8.36c.459 0 .87-.24 1.103-.645.23-.402.233-.877.008-1.271L7.595 1.7a1.243 1.243 0 00-1.092-.642zM6.5 8.433c.366 0 .668.305.652.69.016.351-.302.659-.652.659a.679.679 0 01-.668-.675c0-.367.304-.674.668-.674zm-.166-4.736a.667.667 0 01.772.38.833.833 0 01.062.338c-.016.337-.046.674-.062 1.012-.029.52-.061 1.041-.09 1.562C7 7.159 7 7.313 7 7.48a.503.503 0 01-.5.491.492.492 0 01-.5-.475l-.136-2.42-.046-.642c0-.354.198-.645.516-.737z",
  fillRule: "evenodd"
});

function SvgErrorSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12
  }, props), _ref);
}

export default SvgErrorSm;